module.exports = __webpack_public_path__ + "static/2-bc02a2ca5927d6bf0c53c445bc4ed555.jpg";